import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import loginReducer from "./slices/loginSlice";
import userReducer from "../routes/dashboard/users/usersSlice";
import dashboardReducer from "./slices/dashboardSlice";
import projectsReducer from "./slices/projectsSlice";
import customersReducer from "./slices/customersSlice";
import invoicesReducer from "./slices/invoicesSlice";
import transactionsReducer from "./slices/transactionsSlice";
import paymentFormReducer from "./slices/paymentFormSlice";
import dropboxFoldersReducer from "./slices/dropboxFoldersSlice";
import assetsReducer from "./slices/assetsSlice";
import profileReducer from "./slices/profileSlice";
import vendorsReducer from "./slices/vendorsSlice";
import vendorMergesReducer from "./slices/vendorMergesSlice";
import clientOverviewReducer from "./slices/clientOverviewSlice";
import reportingReducer from "./slices/reportingSlice";
import progressPhotosReducer from "./slices/progressPhotosSlice";
import sourceReducer from "./slices/sourceSlice";

const store = configureStore({
  reducer: {
    users: userReducer,
    login: loginReducer,
    dropboxFolders: dropboxFoldersReducer,
    assets: assetsReducer,
    projects: projectsReducer,
    dashboard: dashboardReducer,
    customers: customersReducer,
    invoices: invoicesReducer,
    transactions: transactionsReducer,
    paymentForm: paymentFormReducer,
    profile: profileReducer,
    vendors: vendorsReducer,
    vendorMerges: vendorMergesReducer,
    clientOverview: clientOverviewReducer,
    reporting: reportingReducer,
    progressPhotos: progressPhotosReducer,
    source: sourceReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export typed hooks
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
